import { Reveal } from "../components/Reveal";
import { SectionHead } from "../components/SectionHead";

export const StealthTech = ({ t }) => (
  <section id="tech" data-testid="section-stealth" className="py-32 md:py-48 border-b border-[#272A2E]">
    <div className="max-w-[1600px] mx-auto px-6 md:px-10">
      <Reveal><SectionHead index={t.index} title={t.title} lead={t.lead} /></Reveal>
      <div className="grid grid-cols-12 gap-6 md:gap-10">
        <Reveal className="col-span-12 lg:col-span-5" delay={0.1}>
          <div className="relative group" style={{ clipPath: "polygon(0 0, 100% 0, 100% calc(100% - 32px), calc(100% - 32px) 100%, 0 100%)" }}>
            <img src="/images/material_macro.png" alt={t.image_caption} data-testid="stealth-image"
              className="w-full aspect-[4/5] object-cover grayscale opacity-70 group-hover:grayscale-0 group-hover:opacity-100 transition-[filter,opacity] duration-700" />
          </div>
          <p className="mt-4 text-[10px] font-mono tracking-[0.2em] uppercase text-[#8A8F98]">+ {t.image_caption}</p>
        </Reveal>
        <div className="col-span-12 lg:col-span-7 grid sm:grid-cols-2 gap-px bg-[#272A2E] border border-[#272A2E]">
          {t.features.map((f, i) => (
            <Reveal key={f.t} delay={0.15 + i * 0.08} className="bg-[#0A0B0D]">
              <div data-testid={`stealth-feature-${i}`} className="p-8 md:p-10 h-full hover:bg-[#121417] transition-colors duration-500 group">
                <p className="text-xs font-mono text-[#FF2A00] tracking-[0.2em] mb-6">0{i + 1}</p>
                <h3 className="font-display text-xl md:text-2xl font-bold uppercase text-white tracking-tight group-hover:drop-shadow-[0_0_8px_rgba(255,42,0,0.4)]">{f.t}</h3>
                <p className="mt-4 text-sm font-mono tracking-tight text-[#8A8F98] leading-relaxed">{f.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
